/**
 * グローバルナビゲーション（GNAV）モジュール
 */
export const GNAV = {
  init(GLOBALSITE) {
    const body = document.body
    const gnavSwitch = document.querySelector('.js-gnav-switch')
    const dropdowns = document.querySelectorAll('.menu-item-has-children')
    const openClass = 'is-gnav-open'
    const activeClass = 'is-active'
    const currentClass = 'is-current'
    const duration = 300

    if (!gnavSwitch) return

    // オーバーレイを追加
    const overlay = document.createElement('div')
    overlay.className = 'l-overlay js-overlay'
    body.appendChild(overlay)

    this.setupDropdown(dropdowns, activeClass, duration, GLOBALSITE)
    this.setupGnavSwitch(gnavSwitch, body, openClass)
    this.setupOverlay(body, openClass)
    this.applyCurrentStyles(currentClass)
  },

  /**
   * ドロップダウンの設定
   */
  setupDropdown(dropdowns, activeClass, duration, GLOBALSITE) {
    dropdowns.forEach(dropdown => {
      const anchor = dropdown.querySelector('a')
      const submenu = dropdown.querySelector('.menu-item__children')

      if (!anchor || !submenu) return

      if (GLOBALSITE.COMMON.VARIABLES.range_sp) {
        anchor.addEventListener('click', e => {
          e.preventDefault()
          dropdown.classList.toggle(activeClass)
          // スライドトグル風アニメーション
          if (submenu.style.maxHeight) {
            // submenu.style.transition = `max-height ${duration}ms ease`
            submenu.style.maxHeight = null
          } else {
            // submenu.style.transition = `max-height ${duration}ms ease`
            submenu.style.maxHeight = submenu.scrollHeight + 'px'
          }
        })
      } else {
        dropdown.addEventListener('mouseenter', () => {
          dropdown.classList.add(activeClass)
        })
        dropdown.addEventListener('mouseleave', () => {
          dropdown.classList.remove(activeClass)
        })
      }
    })
  },

  /**
   * ナビ開閉スイッチの設定
   */
  setupGnavSwitch(gnavSwitch, body, openClass) {
    gnavSwitch.addEventListener('click', e => {
      e.preventDefault()
      body.classList.toggle(openClass)
    })
  },

  /**
   * オーバーレイクリックでナビを閉じる
   */
  setupOverlay(body, openClass) {
    const overlay = document.querySelector('.js-overlay')
    if (overlay) {
      overlay.addEventListener('click', () => {
        body.classList.remove(openClass)
      })
    }
  },

  /**
   * currentページにスタイルを適用
   */
  applyCurrentStyles(currentClass) {
    const menuItems = document.querySelectorAll('.l-header__menu [class*="current"] a')
    menuItems.forEach(link => {
      link.classList.add(currentClass)
    })
  },
}
